import { Button, TextInput } from 'components/Form'
import { useNavigate } from 'react-router-dom'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { apiVerify } from 'services/AuthService'
import { useDispatch, useSelector } from 'react-redux'
import { onSignInSuccess } from 'store/auth/sessionSlice'
import { setCompany, setCustomer } from 'store/filterdata/filterDataSlice'
import { setUser } from 'store/auth/userSlice'

const validationSchema = Yup.object().shape({
    mfa_token: Yup.string().required('please enter your otp'),
})

export default function Verify() {
    const navigate = useNavigate()
    const user = useSelector(state => state.auth.user)
    const dispatch = useDispatch()

    const onVerify = async (values, setSubmitting) => {
        setSubmitting(true)
        apiVerify(values)
            .then(resp => {
                if (resp.data) {
                    const { access, refresh } = resp.data?.token
                    dispatch(onSignInSuccess({ token: access, refreshToken: refresh }))
                    dispatch(setCompany(resp.data?.company_id ? resp.data?.company_id : ''))
                    dispatch(setCustomer(resp.data?.customer_id ? resp.data?.customer_id : ''))
                    if (resp.data) {
                        resp.data.user = {
                            id: resp.data?.user_id,
                            email: resp.data?.email || values?.email,
                            first_name: resp.data?.first_name,
                            last_name: resp.data?.last_name,
                            role: resp.data?.role,
                            super_user: resp.data?.super_user,
                            company: resp.data?.company_id,
                            customer: resp.data?.customer_id,
                        }

                        dispatch(
                            setUser(
                                resp.data.user || {
                                    avatar: '',
                                    first_name: 'User',
                                    last_name: '',
                                    userName: 'user@123',
                                    email: 'user@gmail.com',
                                }
                            )
                        )
                    }
                }
                Success('Verify successfully!')
                navigate('/')
            })
            .catch(error => console.log('Error:', error))
        setSubmitting(false)
    }

    return (
        <>
            <span className="flex justify-center">
                <img className="w-[40%] h-[40%]" src="/images/logo.png" alt="error" />
            </span>
            {/* <h2 className="my-3 text-lg font-bold text-black dark:text-white sm:text-title-md">Reset Password</h2> */}
            <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">
                Please check your email or authenticator app for the OTP.
            </h4>
            <Formik
                initialValues={{
                    mfa_token: '',
                    email: user?.email,
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                    onVerify(values, setSubmitting)
                }}
            >
                {({ touched, errors, isSubmitting }) => (
                    <Form className="flex flex-col gap-3">
                        <Field name="mfa_token">
                            {({ field, form }) => (
                                <TextInput
                                    id="mfa_token"
                                    name="mfa_token"
                                    label={'OTP'}
                                    autoComplete="mfa_token"
                                    error={errors.mfa_token && touched.mfa_token}
                                    message={errors.mfa_token}
                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                />
                            )}
                        </Field>
                        <Button
                            className="w-full mt-3 text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                            disabled={isSubmitting}
                            type="submit"
                        >
                            {isSubmitting ? 'verifying...' : 'Verify'}
                        </Button>
                    </Form>
                )}
            </Formik>
        </>
    )
}
